import { render, staticRenderFns } from "./Feedbacks.vue?vue&type=template&id=1ca3723e&scoped=true&"
import script from "./Feedbacks.vue?vue&type=script&lang=js&"
export * from "./Feedbacks.vue?vue&type=script&lang=js&"
import style0 from "./Feedbacks.vue?vue&type=style&index=0&id=1ca3723e&prod&scoped=true&lang=scss&"
import style1 from "./Feedbacks.vue?vue&type=style&index=1&id=1ca3723e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca3723e",
  null
  
)

export default component.exports